import { translateCaseStage } from '@common/intl/case-stage'
import type { LocalizedStatus } from '@common/types'
import { StatusType } from '@common/types'
import type { CaseStage } from '@gql'
import { CaseFlow, CaseStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const caseStatusMessages = defineMessages({
  closed: {
    defaultMessage: 'Closed',
    description: 'case status title',
  },
  done: {
    defaultMessage: 'Done',
    description: 'case status title',
  },
  open: {
    defaultMessage: 'Open',
    description: 'case status title',
  },
  pending: {
    defaultMessage: 'Pending',
    description: 'case status title',
  },
  screening: {
    defaultMessage: 'Screening',
    description: 'case status title',
  },
})

export function localizeCaseStatus(
  intl: IntlShape,
  status: CaseStatus,
  stage: CaseStage,
  closeReason: string | null,
  flow?: CaseFlow | null,
): LocalizedStatus {
  switch (status) {
    case CaseStatus.PENDING:
      // A PENDING on-screened-assign case is mid-screening — the
      // bot playbook is engaging; assignment comes with its handoff. It
      // needs no operator attention yet, hence INFO rather than WARNING.
      if (flow === CaseFlow.ON_SCREENED_ASSIGN) {
        return {
          localized: intl.formatMessage(caseStatusMessages.screening),
          status: StatusType.INFO,
        }
      }

      return {
        localized: intl.formatMessage(caseStatusMessages.pending),
        status: StatusType.WARNING,
      }
    case CaseStatus.OPEN:
      return {
        localized: translateCaseStage(intl, stage),
        status: StatusType.INFO,
      }
    case CaseStatus.CLOSED:
      if (closeReason) {
        return {
          localized: closeReason,
          status: StatusType.ERROR,
        }
      } else {
        return {
          localized: intl.formatMessage(caseStatusMessages.done),
          status: StatusType.SUCCESS,
        }
      }
  }
}
